// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { WEB_HOTEL_FOOTER_VIEW_CLASS_NAME } from "../../../../../core/constants/className";
import { useTranslationParamsWithStatistics } from "../../../../hooks/useTranslationParamsWithStatistics";
import { ProductArticle } from "../../../common/productArticle/ProductArticle";
import {
    HERO_IMAGE,
} from "../../../../assets/images";
import {
    T_WEB_HOTEL_FOOTER_DESCRIPTION,
    T_WEB_HOTEL_FOOTER_READ_MORE,
    T_WEB_HOTEL_FOOTER_TITLE,
    T_SITE_NAME,
} from "../../../../../core/constants/translation";
import {
    VIRTUALSERVERS_ROUTE,
    WEBHOTELS_FOOTER_ROUTE,
} from "../../../../../core/constants/route";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import { SEODiv } from "../../../common/seo/SEODiv";
import "./WebHotelFooterView.scss";

export interface WebHotelFooterViewProps {
    readonly t: TranslationFunction;
    readonly className ?: string;
}

export function WebHotelFooterView (props: WebHotelFooterViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const description : string[] = t(T_WEB_HOTEL_FOOTER_DESCRIPTION).split(/\n\n+/);
    const translationParams = useTranslationParamsWithStatistics();
    return (
        <SEODiv
            className={ WEB_HOTEL_FOOTER_VIEW_CLASS_NAME + (className ? ` ${className}` : "") }
            path={WEBHOTELS_FOOTER_ROUTE}
            title={ t( T_WEB_HOTEL_FOOTER_TITLE, translationParams ) }
            description={ t( T_WEB_HOTEL_FOOTER_DESCRIPTION, translationParams ) }
            siteName={ t( T_SITE_NAME, translationParams ) }
        >
            <ProductArticle
                t={t}
                className={WEB_HOTEL_FOOTER_VIEW_CLASS_NAME+'-article'}
                previewImage={HERO_IMAGE}
                title={t(T_WEB_HOTEL_FOOTER_TITLE, translationParams)}
                description={description}
                translationParams={translationParams}
                secondaryButtonTo={VIRTUALSERVERS_ROUTE}
                secondaryButtonText={t(T_WEB_HOTEL_FOOTER_READ_MORE, translationParams)}
            />
        </SEODiv>
    );

}
